const initialleave = {
    leavedatas : [],
    changelogs : {}
};

const leavedataReducer = (leave = initialleave, action) => {
    switch (action.type) {
        
        case 'GET_LEAVE_DATA_BY_EMPID':
        return {
            ...leave, leavedatas: action.payload.data
        };
        case 'GET_CHANGE_LEAVE_LOG_STATUS':
        return {
            ...leave, changelogs: action.payload.data
        };
        default:
            return leave;
    }
}
export default leavedataReducer;